<!--
발송작업 > 배송상품오류정보
-->
<template>
    <div class="uk-card uk-card-default simple-card uk-card-small">

        <div class="uk-card-body p-1rem">
            <div class="title">
                <i class="material-icons">error</i>
                오류정보
            </div>
            <!-- 오류정보 -->
            <table class="error-info">

                <tr>
                    <th>
                        오류종류
                    </th>
                    <td>
                        {{ shipError.type_text }}
                    </td>
                </tr>

                <tr>
                    <th>
                        오류상세
                    </th>
                    <td v-nl2br="shipError.memo">
                    </td>
                </tr>

                <tr>
                    <th>
                        오류사진
                    </th>
                    <td>
                        <app-file-list
                            :type="1"
                            :cm-id="shipError.cm_id"

                            hide-header
                        ></app-file-list>
                    </td>
                </tr>

            </table>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 오류정보
            shipError: Object,
        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>

    .title {
        color: #000;
        font-size: 1.25rem;
        text-align: left;
        .material-icons {
            font-size: 1.75rem;
        }
    }

    // 테이블
    .error-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #cfcfcf;
            font-weight: normal;

            padding: 10px;
            color: #000;
        }

        th {
            font-size: 1.25rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.75rem;
                color: #aaa;
            }

        }
        td {
            text-align: left;
            font-size: 1.25rem;
            color: #000;
        }

    }
</style>